import Vue from 'vue';
import Router from 'vue-router';
// import store from '../vuex/index.js'

import landingPage from './../views/landingPage.vue';
import soundMap from './../views/soundMap.vue';
import openDays from './../views/openDays.vue';
import company from './../views/company.vue';
import companies from './../views/companies.vue';
import programs from './../views/programs.vue';
import extraPrograms from './../views/programs-extra.vue';
import opendaysDocs from './../views/opendaysDocs.vue';
import teamPage from '../views/team.vue';
import newsODPage from '../views/newsODPage.vue';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: '/' // todo
    },
    {
      path: '/',
      name: 'Home',
      component: landingPage,
    },
    {
      path: '/soundmap',
      name: 'Sound Map',
      component: soundMap
    },
    {
      path: '/opendays/:year',
      name: 'Open Days',
      component: openDays
    },
    {
      path: '/company/:id/:year',
      name: 'Company',
      component: company,
      params: true
    },
    {
      path: '/companies/:year',
      name: 'Companies',
      component: companies
    },
    {
      path: '/programs/:year',
      name: 'Programs',
      component: programs
    },
    {
      path: '/extra-programs/:year',
      name: 'ExtraPrograms',
      component: extraPrograms
    },
    {
      path: '/documents',
      name: 'OpendaysDocs',
      component: opendaysDocs
    },
    {
      path: '/team',
      name: 'TeamPage',
      component: teamPage
    },
    {
      path: '/news-opendays',
      name: 'newsODPage',
      component: newsODPage
    },
  ]
});

export default router;
